import React from "react";

import { cn } from "~/components/ui/cn";

/**
 * The container component of the analytics card.
 */
const AnalyticsCard: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <div
      className={cn("rounded-lg border border-gray-100 p-4", className)}
      {...props}
    />
  );
};
AnalyticsCard.displayName = "AnalyticsCard";

const AnalyticsCardContent: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return <div className={cn("space-y-4 p-2", className)} {...props} />;
};
AnalyticsCardContent.displayName = "AnalyticsCardContent";

/**
 * The label component of the analytics card. This component is used to display the label inside the container.
 */
const AnalyticsCardLabel: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <dt
      className={cn(
        "text-xs font-semibold uppercase tracking-wider text-gray-700",
        className,
      )}
      {...props}
    />
  );
};
AnalyticsCardLabel.displayName = "AnalyticsCardLabel";

/**
 * The value component of the analytics card. This component is used to display the main value inside the container.
 */
const AnalyticsCardValue: React.FC<React.ComponentProps<"dd">> = ({
  className,
  ...props
}) => {
  return (
    <dd
      className={cn("text-3.5xl font-bold text-gray-900", className)}
      {...props}
    />
  );
};
AnalyticsCardValue.displayName = "AnalyticsCardValue";

export {
  AnalyticsCard,
  AnalyticsCardContent,
  AnalyticsCardLabel,
  AnalyticsCardValue,
};
